export const customBoxSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'scroll',
};

export const CustomButtonFieldSx = {
  backgroundColor: '#1e1e1e',
  display: 'flex',
  gap: 0.5,
  justifyContent: 'space-around',
  height: '25%',
  padding: 0.5,
  width: '100%'
};

export const customDataGridSx = {
  '& .MuiDataGrid-columnHeaderTitle': {
    color: '#040404', // ヘッダーの文字色
  },
  '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
    color: '#040404', // ヘッダーのチェックボックスの色（未チェック）
  },
  '& .MuiDataGrid-cell': {
    color: '#e1e1e1', // セルの文字色
  },
  '& .MuiCheckbox-root': {
    color: '#e1e1e1', // チェックボックスの色（未チェック）
  },
  '& .Mui-checked': {
    color: '#1976d2 !important', // チェックボックスの色（チェック済み）
  },
  '& .MuiTablePagination-root': {
    color: '#e1e1e1', // ページネーションの文字色
  },
  '& .MuiTablePagination-actions button': {
    color: '#e1e1e1', // ページネーションのボタンの文字色
  },
};